import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import {
  HistoryForLicenseModel,
  HistoryForLicenseResponse,
} from "models/HistoryForLicense";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { convertISOtoDMYHM } from "common/helpers/convertISO";
import { columns } from "./columns";

type HistoryForLicenseProps = {
  licenseNumber: string;
  data: HistoryForLicenseResponse;
};
const HistoryForLicense = ({ data, licenseNumber }: HistoryForLicenseProps) => {
  const { t } = useTranslation();
  const formatData = data.historyForLicenseNumber.map((item) => {
    const { createdOn } = item;
    const formattedDate = convertISOtoDMYHM(createdOn);
    return {
      ...item,
      createdOn: formattedDate,
    };
  });

  return (
    <>
      <div className="title-and-date">
        <SubTitle className="sub-title-bold">
          {`${t("reportsHistoric")}      -     `}
        </SubTitle>

        <p>{`${t("licenseNumber")} ${licenseNumber}`}</p>
      </div>
      <p>{` ${formatData.length} ${t("reports")}`}</p>
      <BootstrapTable
        striped
        wrapperClasses="reversed-table"
        bordered={false}
        bootstrap4
        keyField="id"
        data={formatData}
        columns={columns}
      />
    </>
  );
};
export default HistoryForLicense;
